export var D2CRefundPolicyRuleRefundChargeUnit;
(function (D2CRefundPolicyRuleRefundChargeUnit) {
    D2CRefundPolicyRuleRefundChargeUnit["PERCENT"] = "PERCENT";
    D2CRefundPolicyRuleRefundChargeUnit["AMOUNT"] = "AMOUNT";
})(D2CRefundPolicyRuleRefundChargeUnit || (D2CRefundPolicyRuleRefundChargeUnit = {}));
